import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Detail from './Detail'
import style from './style.module.less'
import Imgs from './Imgs'
import Video from './Video'
import { Provider } from 'mobx-react'

@inject('stepTwoStore')
@observer
export default class extends Component {
  render() {
    const {
      sessionPictureStore,
      sessionServiceStore,
      sessionCaseStore
    } = this.props.stepTwoStore
    return (
      <div className={style.content}>
        <Imgs />
        <Video />
        <Provider
          sessionPictureStore={sessionPictureStore}
          sessionServiceStore={sessionServiceStore}
          sessionCaseStore={sessionCaseStore}
        >
          <Detail />
        </Provider>
      </div>
    )
  }
}
